export const help = () => `Web bash, version 0.1.3 (react)
Commands:
cowsay [some text]
date
release
clear or cls
reset
player
dungeon
mines
settings
todo
screensaver
`;
